import React from 'react';
import { Button, Modal, ModalBody, Input, Spinner, UncontrolledAlert } from 'reactstrap'; 
import update from 'immutability-helper';
import isEmail from 'validator/lib/isEmail'
import Auth from '../config/Auth';

const nameRegex = /^[a-z\u00C0-\u02AB'´`]+\.?\s([a-z\u00C0-\u02AB'´`]+\.?\s?)+$/i;
const emailRegex = /\S+@\S+\.\S+/;
const passRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm;

class Autenticacao extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isLoading: false,
      auth: false,
      validator: {
        error: null,
      },
      form: {
        email: '',
        senha: '',
        nome: ''
      }
    }

    this.toggle = this.toggle.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.login = this.login.bind(this);
    this.loggout = this.loggout.bind(this);
  }

  toggle() {
    const isOpen = !this.state.isOpen;

    this.setState(state => update(state, {
      isOpen: { $set: isOpen },
      isLoading: { $set: false }
    }))
  }

  onTextChange(e) {
    const value = e.target.value;

    if (e.target.name === "email") {
      this.setState(state => update(state, {
        form:{
          email: { $set: value } 
        }
      }))
    }
    else {
      this.setState(state => update(state, {
        form:{
          senha: { $set: value } 
        }
      }))
    }
  }

  login() {
    this.setState(state => update(state, {
      isLoading: { $set: true },
      validator: {
        error: { $set: null }
      }
    }), () => {
      Auth.autenticate(this.state.form.email, this.state.form.senha, ((message) => {
        this.setState(state => update(state, {
          isLoading: { $set: false },
          validator: {
            error: { $set: message }
          }
        }))
      }), (data) => {
        console.log(data)
          this.setState(state => update(state, {
            isLoading: { $set: false },
            validator: {
              error: { $set: null}
            }
          }), () => {
            this.toggle();
          })

          this.props.callback();
      })
    })
  }

  loggout() {
    this.setState(state => update(state, {
      isLoading: { $set: true },
      validator: {
        error: { $set: null }
      }
    }), () => {
      Auth.loggout((message) => {
        this.setState(state => update(state, {
          isOpen: {$set: true},
          isLoading: {$set:false },
          validator: {
            error:{ $set: message }
          }
        }))
      }, () => {
          this.setState(state => update(state, {
            isLoading: { $set: false }
          }))

          this.props.callback();
      });
    })
  }

  render() {
    return (
      <React.Fragment>{
        <Modal isOpen={this.state.isOpen} toggle={this.toggle}>
          <ModalBody className="p-5">{
            !Auth.isAuthenticated ?
              <React.Fragment>
                <p className="small text-muted text-center">Esta é uma área exclusiva de administradores<br />Para nossos serviços, utilize os nossos apps para <strong>iOS</strong> e <strong>Android</strong></p>
                <Input type="email" placeholder="email" className="mb-2" name="email" value={this.state.form.email} onChange={this.onTextChange} />
                <Input type="password" placeholder="Senha" className="mb-3" name="senha" value={this.state.form.senha} onChange={this.onTextChange} /> {
                  !isEmail(this.state.form.email) || this.state.form.senha.length < 4 || this.state.validator.error !== null ?
                    <React.Fragment> {
                      this.state.form.email.length === 0 ?
                        <UncontrolledAlert color="warning" className="text-center">Informe o seu email</UncontrolledAlert>
                      :
                        !isEmail(this.state.form.email) ? 
                          <UncontrolledAlert color="danger" className="text-center">Email inválido</UncontrolledAlert>
                        :
                          null
                      } {
                        this.state.form.senha.length < 4 ?
                          <UncontrolledAlert color="warning" className="text-center">Informe a sua senha</UncontrolledAlert>
                        :
                          null
                      } {
                        this.state.validator.error !== null ?
                          <UncontrolledAlert color="danger" className="text-center">{ this.state.validator.error }</UncontrolledAlert>
                        :
                          null
                      } {
                        this.state.validator.error !== null ? 
                          <Button onClick={this.login} className="float-right" color="dark">Entrar</Button>
                        :
                          <Button onClick={this.login} disabled className="float-right" color="dark">Entrar</Button>
                      }
                    </React.Fragment>
                  :
                    this.state.isLoading ?
                      <Button onClick={this.login} className="float-right" disabled color="dark">
                        <Spinner className="spinner-grow spinner-grow-sm"></Spinner>
                      </Button>
                      :
                      <Button onClick={this.login} className="float-right" color="dark">Entrar</Button>
                }
                <Button onClick={this.toggle} className="float-right mr-2" color="light">Cancelar</Button>
              </React.Fragment>
            :
              null
          }
          </ModalBody> 
        </Modal>
        } {
          !Auth.isAuthenticated ? 
            <Button color="dark" onClick={this.toggle}>Entrar</Button>
            :
              <React.Fragment> {
                this.state.isLoading ?
                  <Button onClick={this.login} className="float-right" disabled color="dark">
                    <Spinner className="spinner-grow spinner-grow-sm"></Spinner>
                  </Button>
                :
                  <Button color={this.state.validator.error ? "danger" : "dark"} onClick={this.loggout}>Sair</Button>
                }
              </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

export default (Autenticacao)